// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shareableLink_link__1kWMh {\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n  .shareableLink_link__1kWMh .shareableLink_input__2kw65 {\n    width: 100%;\n    font-size: 11px; }\n", ""]);
// Exports
exports.locals = {
	"link": "shareableLink_link__1kWMh",
	"input": "shareableLink_input__2kw65"
};
module.exports = exports;
